import { Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

import classes from './TabButtons.module.scss';

interface TabButtonsProps {
  tabs: string[];
  activeTab: number;
  size?: 'small' | 'medium' | 'large';
  onTabClick: (index: number) => void;
}

export const TabButtons: React.FC<TabButtonsProps> = ({ tabs, size, activeTab, onTabClick }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const responsiveSize = size ?? (isSmallScreen ? 'small' : 'medium');

  return (
    <Stack direction='row' sx={{ gap: { xs: 2, md: 1, lg: 2 } }}>
      {tabs.map((tab, index) => (
        <Button
          key={tab}
          variant='contained'
          size={responsiveSize}
          disabled={activeTab === index}
          onClick={() => onTabClick(index)}
        >
          <span className={classes.btnContent}>{tab}</span>
        </Button>
      ))}
    </Stack>
  );
};
